// Types
import { TCaseState } from "Types";
// Enums
import { CaseActionTypeEnum } from "Enums";
// Interfaces
import { 
    ICaseAction,
    ICasePhaseAction, 
    ICaseSelectedAction, 
    ICaseSelectedInfoAction,
    ICaseSetSelectedEntity,
    ICaseSelectedConcept, 
    ICaseSelectedTechnology,
    ISetCaseConceptTechnologyListAction,
    IUpdateTechSideNoteListAction,
    IUpdateTechnologyVoteAction,
    IUpdateTechnologyRateAction,
    ICaseSetQueryCount
} from "Interfaces";
// Logics
import { CaseReducerLogicSingleton } from "Logics";

export const CaseReducer = (state: TCaseState, action: ICaseAction): TCaseState => {
    // First, we figure out what action
    // has been fired:
    switch (action.type) {
        // Then, for each action
        // we describe an according state update.
        case CaseActionTypeEnum.SetSelectedCaseInfo:
            const setSelectedCaseInfoAction = action as ICaseSelectedInfoAction;
            return {
                ...state,
                selectedCaseId: setSelectedCaseInfoAction.newCaseId
            };
        case CaseActionTypeEnum.SetSelectedCase:
            const setSelectedCaseAction = action as ICaseSelectedAction;
            return {
                ...state,
                selectedCase: setSelectedCaseAction.newSelectedCase,
                isDeliveryRedesign: setSelectedCaseAction.newSelectedCase ? setSelectedCaseAction.newSelectedCase.isDeliveryRedesign : false,
                isDynamicDelivery: setSelectedCaseAction.newSelectedCase ? setSelectedCaseAction.newSelectedCase.isDynamicDelivery : false,
                selectedTechnologyId: undefined,
                selectedConceptId: undefined
            };
        case CaseActionTypeEnum.SetCaseQueryCount:
            const setCaseQueryCount = action as ICaseSetQueryCount;

            const selectedCase = state.selectedCase;

            if(!selectedCase) return { ...state };
            selectedCase.queryCount = setCaseQueryCount.newQueryCount;

            return {
                selectedCase: selectedCase,
                ...state,
            };
        case CaseActionTypeEnum.SetCasePhase:
            const setCasePhase = action as ICasePhaseAction;
            return {
                ...state,
                casePhase: setCasePhase.casePhase.toLowerCase(),
                selectedTechnologyId: undefined,
                selectedOriginalTechnologyId: undefined,
                selectedConceptId: undefined
            };
        case CaseActionTypeEnum.SetCaseSelectedEntity:
            const setSelectedEntity = action as ICaseSetSelectedEntity;
            return {
                ...state,
                selectedTechnologyId: undefined,
                selectedOriginalTechnologyId: undefined,
                selectedConceptId: undefined,
                selectedEntityId: setSelectedEntity.selectedEntityId,
                selectedEntityNumbering: setSelectedEntity.selectedEntityNumbering,
                selectedEntityName: setSelectedEntity.selectedEntityName
            };
        case CaseActionTypeEnum.SetCaseSelectedConcept:
            const setSelectedConcept = action as ICaseSelectedConcept;
            return {
                ...state,
                selectedTechnologyId: undefined,
                selectedOriginalTechnologyId: undefined,
                selectedEntityId: undefined,
                selectedConceptId: setSelectedConcept.selectedConceptId,
                selectedEntityNumbering: setSelectedConcept.selectedEntityNumbering,
                selectedEntityName: setSelectedConcept.selectedEntityName
            };
        case CaseActionTypeEnum.SetCaseSelectedTechnology:
            const setSelectedTechnology = action as ICaseSelectedTechnology;
            return {
                ...state,
                selectedEntityId: undefined,
                selectedConceptId: undefined,
                selectedOriginalTechnologyId: setSelectedTechnology.selectedOriginalTechnologyId,
                selectedTechnologyId: setSelectedTechnology.selectedTechnologyId,
                selectedEntityNumbering: setSelectedTechnology.selectedEntityNumbering,
                selectedEntityName: setSelectedTechnology.selectedEntityName
            };
        case CaseActionTypeEnum.SetCaseConceptTechnologyList:
            const setCaseConceptTechnologyListAction = action as ISetCaseConceptTechnologyListAction;
            return {
                ...state,
                conceptTechnologyList: setCaseConceptTechnologyListAction.caseConceptTechnologyList
            };
        case CaseActionTypeEnum.UpdateTechSideNoteListAction:
            const updateTechSideNoteListAction = action as IUpdateTechSideNoteListAction;
            let isUpdateAlreadyDone = false;

            if (state.conceptTechnologyList && state.conceptTechnologyList.concepts) {
                for (const concept of state.conceptTechnologyList.concepts) {
                    isUpdateAlreadyDone = CaseReducerLogicSingleton
                        .updateTechnologySideNotesInList(
                            updateTechSideNoteListAction,
                            concept.technologies,
                            false
                        );
                }
            }
            
            if (!isUpdateAlreadyDone && 
            state.conceptTechnologyList && 
            state.conceptTechnologyList.additionalTechnologies) {
                CaseReducerLogicSingleton
                        .updateTechnologySideNotesInList(
                            updateTechSideNoteListAction,
                            state.conceptTechnologyList.additionalTechnologies,
                            true
                        );
            }
            
            return {
                ...state
            };

        case CaseActionTypeEnum.UpdateTechnologyVoteAction:
            const updateTechnologyVoteAction = action as IUpdateTechnologyVoteAction;
            let votesUpdateAlreadyDone = false;

            if (state.conceptTechnologyList) {
                for (const concept of state.conceptTechnologyList.concepts) {
                    votesUpdateAlreadyDone = CaseReducerLogicSingleton.updateTechnologyVotesInList(updateTechnologyVoteAction, concept.technologies);
                }

                if (state.conceptTechnologyList.additionalTechnologies && !votesUpdateAlreadyDone) {
                    CaseReducerLogicSingleton.updateTechnologyVotesInList(updateTechnologyVoteAction, state.conceptTechnologyList.additionalTechnologies);
                }
            }
            
            return {
                ...state
            };

        case CaseActionTypeEnum.UpdateTechnologyRateAction:
            const updateTechnologyRateAction = action as IUpdateTechnologyRateAction;
            let ratesUpdateAlreadyDone = false;

            if (state.conceptTechnologyList) {
                for (const concept of state.conceptTechnologyList.concepts) {
                    ratesUpdateAlreadyDone = CaseReducerLogicSingleton.updateTechnologyRatesInList(updateTechnologyRateAction, concept.technologies);
                }

                if (state.conceptTechnologyList.additionalTechnologies && !ratesUpdateAlreadyDone) {
                    CaseReducerLogicSingleton.updateTechnologyRatesInList(updateTechnologyRateAction, state.conceptTechnologyList.additionalTechnologies);
                }
            }
            
            return {
                ...state
            };
        // If the action is unknown
        // we return the current state:
        default:
            return state;
    }
};